import { useTranslation } from 'react-i18next';
import CTASubnav from 'typescript/components/cta_subnav/cta_subnav';
import { useProductContext } from 'typescript/pages/product/contexts/product_context';
import CDP_EVENT_NAMES from 'typescript/constants/cdp_events';

import { trackCdp } from 'utilities/tracking';

// todo: move this to a shared interface file eventually maybe
interface NavItem {
  id: string;
  url: string;
  title: string;
}

const ProductPageCTASubnav = () => {
  const { t } = useTranslation();
  const {
    currentProduct,
    selection,
    onUpdateItemQuantity,
    isUpdateItemQuantityLoading,
    bopisPostalCode,
    bopisPickupLocation,
  } = useProductContext();

  // since we already have the contentful cta_subnav passed to the frontend
  // we can parse the json string to get the title and navItems array
  // this might need to be changed in the future if we stop pulling the subnav data from contentful
  const ctaSubnav = JSON.parse(currentProduct.cta_subnav);
  const title = ctaSubnav?.title || currentProduct?.name;

  // only 1pp have nav items (overview and specs)
  const navItems: NavItem[] = ctaSubnav?.navItems || [];

  const trackClick = (CDPEventName: string, linkName?: string) => {
    trackCdp({
      name: CDPEventName,
      params: {
        feature: 'shop',
        productKey: currentProduct.product_key,
        linkName: linkName || '',
      },
    });
  };

  const onAddToCartClick = () => {
    trackClick(CDP_EVENT_NAMES.PRODUCT_PAGE.CTA_SUBNAV.CLICK_PRIMARY);

    onUpdateItemQuantity({
      variantToken: currentProduct.variant_token,
      productName: currentProduct.name,
      quantity: selection.quantity,
      addOnIds: Object.values(selection.addOns),
      trackingData: currentProduct.tracking_data,
      bopisLocationId: bopisPickupLocation?.location_id,
      bopisSearchPostalCode: bopisPostalCode,
      source: 'pdp-cta-subnav',
    });
  };

  return (
    <CTASubnav>
      <CTASubnav.Title>{title}</CTASubnav.Title>
      <CTASubnav.Navigation>
        {navItems.map((item) => (
          <CTASubnav.Link
            key={item.id}
            href={item.url}
            onClick={() =>
              trackClick(
                CDP_EVENT_NAMES.PRODUCT_PAGE.CTA_SUBNAV.CLICK_LINK,
                item.title,
              )
            }
          >
            {item.title}
          </CTASubnav.Link>
        ))}
      </CTASubnav.Navigation>
      <CTASubnav.Actions>
        <CTASubnav.Primary
          onClick={onAddToCartClick}
          disabled={isUpdateItemQuantityLoading}
        >
          {t('productPage.addToCart')}
        </CTASubnav.Primary>
      </CTASubnav.Actions>
    </CTASubnav>
  );
};

export default ProductPageCTASubnav;
